<h2 mat-dialog-title>{{ data.title }}</h2>
  <div class= "video-dialog">
    <div *ngIf="trustedUrl" class="video-container">
      <iframe
      [src]="trustedUrl"
      frameborder="0" allowtransparency allowfullscreen>
      </iframe>
    </div>
    <mat-dialog-content class="video-text">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
  </div>
  <mat-dialog-actions >
    <button mat-button mat-dialog-close fxFlex>Close</button>
  </mat-dialog-actions>


